export default __webpack_public_path__ + "static/graphik-medium-web-b549568fd3498389ce1e069ac50b29c1.woff";